<script>
	import Admin from './Admin.svelte';
	import { onMount } from 'svelte';
	export let name;
	import firebase from 'firebase/app';
	import { auth } from './firebase';
	let user;
	let email;
	let password;
	let errorMessage = "";

	function login() {
		errorMessage = "";
		auth.signInWithEmailAndPassword(email, password).catch(function(error) {
			// Handle Errors here.
			var errorCode = error.code;
			errorMessage = error.message;
			// ...
		});
	};

	function logout() {
		console.log('logout!');
		auth.signOut()
			.then(()=> {
				console.log('successful logout',user);
				user="";
			}).catch((error)=>{
				console.error('logout error: ',error);
			})
	}

	onMount(async () => {

		firebase.auth().onAuthStateChanged(function(userInfo) {
			if (userInfo) {
				console.log('got a user: ',user);
				user = userInfo;
			} else {
				console.log('no user');
				user = "";
			}
		});
	});
</script>

<main>
	<section>
		{#if user}
			<!-- <Profile {...user} /> -->
			<button on:click={logout}>Logout</button>
			<Admin />
			<!-- <Todos uid={user.uid} /> -->
		{:else}
			<h1>Hello {name}!</h1>
			<p>Visit the <a href="https://svelte.dev/tutorial">Svelte tutorial</a> to learn how to build Svelte apps.</p>
			<input bind:value={email} placeholder="Enter email"><br/>
			<input bind:value={password} placeholder="Enter password" type="password"><br/>
			<button on:click={login}>
				Signin
			</button>
			<br/><span class="error">{errorMessage}</span>
			<!-- <Admin /> -->
		{/if}
	</section>

</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		/* max-width: 240px; */
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	button {
		cursor: pointer;
	}


	.error {
		color: #ff3e00;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>